export default __webpack_public_path__ + "media/images/shaded-background-bbf8f89a5de25b94deb51d5538bf9770.png";